/* Carturio V11 — accessible navigation helpers */
(function () {
  'use strict';
  if (window.__carturioV11NavigationReady) return;
  window.__carturioV11NavigationReady = true;
  const reducedMotion = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mountBackToTop = () => {
    if (document.getElementById('CarturioV11BackToTop')) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.id = 'CarturioV11BackToTop';
    button.setAttribute('aria-label', 'Back to top');
    button.title = 'Back to top';
    button.textContent = '↑';
    button.hidden = true;
    document.body.appendChild(button);
    let scheduled = false;
    const update = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(() => {
        scheduled = false;
        const visible = window.scrollY > 650;
        button.hidden = !visible;
        button.classList.toggle('is-visible', visible);
      });
    };
    button.addEventListener('click', () => window.scrollTo({ top: 0, behavior: reducedMotion() ? 'auto' : 'smooth' }));
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('pageshow', update);
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountBackToTop, { once: true });
  else mountBackToTop();
})();
